import { Component } from '@angular/core';
import { NavParams, NavController, LoadingController, AlertController, ToastController, Events, ModalController } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Database } from '../../providers/database';
import { Utilities } from '../../providers/utilities';
import { Translate } from '../../providers/translate';
import { AuthData } from '../../providers/auth';
import { TranslateService } from '@ngx-translate/core';
import { EventNotesPage } from '../../pages/event-notes/event-notes';
import { EventQuestionsPage } from '../../pages/event-questions/event-questions';
import { EventOpinometerPage } from '../../pages/event-opinometer/event-opinometer';
import { Observable} from 'rxjs/Observable';

@Component({
  selector: 'event-now',
  templateUrl: 'event-now.html'
})
export class EventNowComponent {

  obs: any;
  obsNow: any;
  obsRelatedNow: any;
  obsListener: any;
  event: any;
  changeCount: any;
  client: any;
  dataNow: any;
  componentState: any;
  configNow: any;
  timeLeft: any;
  textTranslate: any;

  constructor(public eventProvider: EventData, public params: NavParams, public ut: Utilities, public nav: NavController, public loadingCtrl: LoadingController, events: Events, translate: Translate, public db: Database, public alertCtrl: AlertController, public toastCtrl: ToastController, public translateProvider: TranslateService, public modal: ModalController, public auth: AuthData) {
		translate.translateGroup(['Cargando', 'Seleccione un opinómetro', 'Cancelar', 'Ok', 'Abrir', 'No se han encontrado opinómetros disponibles', 'Se han activado nuevas encuestas'])
    .then(result => {
      this.textTranslate = result;
    });

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'now').subscribe(stateModule => {
      if (stateModule.$value === true) {
        this.componentState = true;
      } else {
        this.componentState = false;
      }
    });

    this.obs = new Observable(observer => {
      this.obsNow = this.eventProvider.getNow(this.client, this.event.id).subscribe(data => {
        if (data.$value && this.componentState) {
          observer.next(data.$value);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((value) => {
      if (this.obsRelatedNow) {
        this.obsRelatedNow.unsubscribe();
      }

      if (value) {
        // setTimeout(() => {
          this.obsRelatedNow = this.eventProvider.getDiary(this.client, this.event.id, value).subscribe(data => {
            this.dataNow = data;
            this.timeLeft = this.ut.timeLeft(data.end || false);
            this.verifiedOpinometer();
          });
        // }, 500);
      } else {
        // setTimeout(() => {
          this.dataNow = false;
        // }, 500);
      }
    });

    // close de listener where logout user
    events.subscribe('client:logout', () => {
      this.closeListener();
    });
  }

  viewNotes() {
    this.nav.push(EventNotesPage, {event: this.event, client: this.client});
  }

  viewQuestions() {
    this.nav.push(EventQuestionsPage, {event: this.event, diary: this.dataNow.id, client: this.client});
  }

  viewOpinometer() {
    let opinometerData = [];
    let loading = this.loadingCtrl.create({
      content: this.textTranslate['Cargando']
    });
    loading.present();
    let alert = this.alertCtrl.create({
      title: this.textTranslate['Seleccione un opinómetro']
    });

    if (this.dataNow.Params.opinometerState && this.dataNow.Params.opinometers.length > 0) {
      this.obs = new Observable(observer => {
        this.dataNow.Params.opinometers.forEach((opinometer: any, key) => {
          this.db.getData('/Clients/' + this.client.url + '/Opinometers/' + opinometer)
          .then((result: any) => {
            observer.next(result.val());

            if (key == this.dataNow.Params.opinometers.length-1) {
              observer.complete();
            }
          });
        });
      });

      this.obs.subscribe(
        (result) => {
          opinometerData = result;

          alert.addInput({
            type: 'radio',
            label: result.title[this.translateProvider.getDefaultLang()],
            value: result
          });
        }, {},
        () => {
          alert.addButton(this.textTranslate['Cancelar']);
          alert.addButton({
            text: this.textTranslate['Ok'],
            handler: selected => {
              if (selected) {
                let modal = this.modal.create(EventOpinometerPage, {event: this.event, client: this.client, opinometer: selected})
                modal.present();
              }
              loading.dismiss();
            }
          });
          if (this.dataNow.Params.opinometers.length > 1) {
            loading.dismiss().then(() => {
              alert.present();
            })
          } else {
            let modal = this.modal.create(EventOpinometerPage, {event: this.event, client: this.client, opinometer: opinometerData})
            loading.dismiss();
            modal.present();
          }
        }
      );
    } else {
      let toast = this.toastCtrl.create({
        message: this.textTranslate['No se han encontrado opinómetros disponibles'],
        position: 'top',
        duration: 5000,
        showCloseButton: true,
        closeButtonText: this.textTranslate['Ok']
      });

      toast.present().then(() => {
        loading.dismiss();
      });
    }
  }

  verifiedOpinometer() {
    if (this.dataNow.Params.opinometerState && this.dataNow.Params.opinometers.length > 0) {
      let flag = false;

      this.dataNow.Params.opinometers.forEach((opinometer: any, key) => {
        this.db.getData('/Clients/' + this.client.url + '/Opinometers/' + opinometer)
        .then((result: any) => {
          if (result.val().isAlert) {
            if (!flag) {
              flag = true;
              this.db.getData('/Clients/' + this.client.url + '/___OpinometersUsers/' + result.val().id + '/' + this.auth.getUser().uid).then((result2: any) => {
                if (!result2.val()) {
                  let alert = this.alertCtrl.create({
                    title: this.event.title,
                    buttons: [{
                      text: this.textTranslate['Cancelar'],
                      handler: () => {}
                    },{
                      text: this.textTranslate['Abrir'],
                      handler: () => {
                        this.viewOpinometer();
                      }
                    }]
                  });

                  if (this.dataNow.Params.opinometers.length > 1) {
                    alert.setMessage(this.textTranslate['Se han activado nuevas encuestas'])
                  } else {
                    alert.setMessage(result.val().message[this.translateProvider.getDefaultLang()])
                  }

                  alert.present();
                }
              });
            }
          }
        });
      });
    }
  }

  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Now');
      this.obsListener.unsubscribe();
    }
    if (this.obsNow) {
      this.obsNow.unsubscribe();
    }
    if (this.obsRelatedNow) {
      this.obsRelatedNow.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-now/event-now.ts